/**
 * TicketPriorityBadge Component
 *
 * Displays ticket priority with appropriate styling.
 */

import React from 'react';
import type { SupportTicketPriority } from '../../../types/support-ticket.types';
import { priorityLabels, priorityColors } from '../../../types/support-ticket.types';

interface TicketPriorityBadgeProps {
  priority: SupportTicketPriority;
}

export const TicketPriorityBadge: React.FC<TicketPriorityBadgeProps> = ({ priority }) => {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${priorityColors[priority]}`}>
      {priorityLabels[priority]}
    </span>
  );
};
